module.exports = __webpack_public_path__ + "img/7_uk.96d626e9.svg";